import React from 'react';
import {connect} from 'react-redux';
import {FormattedMessage} from 'react-intl';
import {Link} from 'react-router-dom';
import {requestImpesonate} from '../../actions/action_auth';
import {changeAdminUserListPage, requestAdminUserList, changeAdminUserListFilter} from '../../actions/action_admin_user';
import Alert from '../Alert';
import Icon from '../Icon';
import Title from '../Title';
import messages from '../../../res/translations/messages';
import Pager from '../Pager';
import Loader from '../Loader';
import UserItem from './UserItem';
import PaginationFilter from '../PaginationFilter';

const PAGE_SIZE = 10;

class UserList extends React.Component {
    constructor(props) {
        super(props);
        this.goToPage = this.goToPage.bind(this);
        this.handleApplyFilters = this.handleApplyFilters.bind(this);
        this.handleClearFilters = this.handleClearFilters.bind(this);
    }

    componentDidMount() {
        this.loadCurrentPage();
    }

    componentDidUpdate(prevProps) {
        if (this.props.user.id !== prevProps.user.id) {
            this.props.history.push('/');
            return;
        }

        if (prevProps.page !== this.props.page || (prevProps.invalid !== this.props.invalid && this.props.invalid)) {
            this.loadCurrentPage();
        }

        if (this.props.page > 1 && this.props.items.length === 0) {
            this.props.changeSurveyListPage(1);
        }
    }

    loadCurrentPage() {
        const {filterText, sortBy} = this.props;
        this.props.requestAdminUserList(filterText, (this.props.page - 1) * PAGE_SIZE, PAGE_SIZE, sortBy);
    }

    goToPage(page) {
        this.props.changeAdminUserListPage(page);
    }

    handleApplyFilters(filterText, sortBy) {
        this.props.changeAdminUserListFilter(filterText, sortBy);
        this.props.changeAdminUserListPage(1);
        this.props.requestAdminUserList(filterText, (this.props.page - 1) * PAGE_SIZE, PAGE_SIZE, sortBy);
    }

    handleClearFilters() {
        this.props.changeAdminUserListFilter('', '');
        this.props.changeAdminUserListPage(1);
        this.props.requestAdminUserList('', (this.props.page - 1) * PAGE_SIZE, PAGE_SIZE, '');
    }

    render() {
        const {count, error, items, loading, requestImpesonate} = this.props;
        const actions = (
            <div>
                <Link className="btn btn-primary" to="/admin/users/create">
                    <Icon icon="new-doc" /> <FormattedMessage {...messages.admin.users.create} />
                </Link>
            </div>
        );
        return (
            <div className="fluid-container">
                <Title actions={actions}><FormattedMessage {...messages.admin.users.title} /></Title>
                <div className="row mb-3 align-items-center">
                    <div className="col-auto">
                        <PaginationFilter
                            filterPlaceholder={messages.admin.users.list.filterPlaceholder}
                            sortPlaceholder={messages.admin.users.list.sort.placeholder}
                            sortOptions={[
                                {value: 'name:asc', label: messages.admin.users.list.sort.name.asc},
                                {value: 'name:desc', label: messages.admin.users.list.sort.name.desc},
                                {value: 'email:asc', label: messages.admin.users.list.sort.email.asc},
                                {value: 'email:desc', label: messages.admin.users.list.sort.email.desc},
                            ]}
                            onApply={this.handleApplyFilters}
                            onClear={this.handleClearFilters}
                            initialFilterText={this.props.filterText}
                            initialSortBy={this.props.sortBy}
                            applyLabel={messages.dashboard.buttons.apply}
                            resetLabel={messages.admin.users.list.reset}
                        />
                    </div>
                    <div className="col ml-auto text-right">
                        <Pager className="justify-content-end" pages={Math.ceil(count / PAGE_SIZE)} current={this.props.page} onClick={this.goToPage} />
                    </div>
                </div>
                {loading ? <Loader /> : (
                    <>
                        <Alert error={error} />
                        <div className="table-responsive">
                            <table className="table table-vcenter">
                                <thead>
                                    <tr>
                                        <th><FormattedMessage {...messages.admin.users.email} /></th>
                                        <th><FormattedMessage {...messages.admin.users.name} /></th>
                                        <th><FormattedMessage {...messages.admin.users.organization} /></th>
                                        <th><FormattedMessage {...messages.admin.users.status} /></th>
                                        <th><FormattedMessage {...messages.admin.users.roles} /></th>
                                        {/* <th><FormattedMessage {...messages.admin.users.allowEvents} /></th> */}
                                        {/* <th><FormattedMessage {...messages.admin.users.isPinpointEnabled} /></th> */}
                                        {/* <th><FormattedMessage {...messages.admin.users.isSendEnabled} /></th> */}
                                        <th><FormattedMessage {...messages.admin.users.createdAt} /></th>
                                        <th />
                                    </tr>
                                </thead>
                                <tbody>
                                    {items.map((item) => <UserItem key={item.id} {...item} onImpersonate={requestImpesonate} />)}
                                </tbody>
                            </table>
                        </div>
                    </>
                )}
                <Pager className="justify-content-end" pages={Math.ceil(count / PAGE_SIZE)} current={this.props.page} onClick={this.goToPage} />
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    count: state.admin.users.count,
    page: state.admin.users.page,
    items: state.admin.users.items,
    error: state.admin.users.error,
    loading: state.admin.users.loading,
    user: state.auth.user,
    filterText: state.admin.users.filterText,
    sortBy: state.admin.users.sortBy,
});

export default connect(mapStateToProps, {changeAdminUserListPage, requestAdminUserList, requestImpesonate, changeAdminUserListFilter})(UserList);
